export const TKeyTerms = {
  TERMS_AND_CONDITIONS: "TERMS_AND_CONDITIONS",
  TERMS_DATE: "TERMS_DATE",
  TERMS_DESCRIPTION: "TERMS_DESCRIPTION",
  TERMS_SUMMARY_TITLE: "TERMS_SUMMARY_TITLE",
  TERMS_SUMMARY_TEXT: "TERMS_SUMMARY_TEXT",
  TERMS_LEGAL: "TERMS_LEGAL",
  TERMS_LEGAL_EDITOR: "TERMS_LEGAL_EDITOR",
  TERMS_LEGAL_EDITOR_TEXT: "TERMS_LEGAL_EDITOR_TEXT",
  TERMS_LEGAL_EDITOR_LI_BOLD_1: "TERMS_LEGAL_EDITOR_LI_BOLD_1",
  TERMS_LEGAL_EDITOR_LI_TEXT_1: "TERMS_LEGAL_EDITOR_LI_TEXT_1",
  TERMS_LEGAL_EDITOR_LI_BOLD_2: "TERMS_LEGAL_EDITOR_LI_BOLD_2",
  TERMS_LEGAL_EDITOR_LI_TEXT_2: "TERMS_LEGAL_EDITOR_LI_TEXT_2",
  TERMS_LEGAL_EDITOR_LI_BOLD_3: "TERMS_LEGAL_EDITOR_LI_BOLD_3",
  TERMS_LEGAL_EDITOR_LI_TEXT_3: "TERMS_LEGAL_EDITOR_LI_TEXT_3",
  TERMS_LEGAL_EDITOR_LI_BOLD_4: "TERMS_LEGAL_EDITOR_LI_BOLD_4",
  TERMS_LEGAL_EDITOR_LI_TEXT_4: "TERMS_LEGAL_EDITOR_LI_TEXT_4",
  TERMS_LEGAL_EDITOR_LI_BOLD_5: "TERMS_LEGAL_EDITOR_LI_BOLD_5",
  TERMS_LEGAL_EDITOR_LI_BOLD_6: "TERMS_LEGAL_EDITOR_LI_BOLD_6",
  TERMS_LEGAL_EDITOR_LI_TEXT_6: "TERMS_LEGAL_EDITOR_LI_TEXT_6",
  TERMS_LEGAL_EDITOR_LI_BOLD_7: "TERMS_LEGAL_EDITOR_LI_BOLD_7",
  TERMS_LEGAL_EDITOR_LI_TEXT_7: "TERMS_LEGAL_EDITOR_LI_TEXT_7",
  TERMS_LEGAL_EDITOR_LI_BOLD_8: "TERMS_LEGAL_EDITOR_LI_BOLD_8",
  TERMS_LEGAL_EDITOR_LI_BOLD_9: "TERMS_LEGAL_EDITOR_LI_BOLD_9",
  TERMS_LEGAL_EDITOR_LI_BOLD_10: "TERMS_LEGAL_EDITOR_LI_BOLD_10",
  TERMS_LEGAL_HOSTING: "TERMS_LEGAL_HOSTING",
  TERMS_LEGAL_HOSTING_TEXT: "TERMS_LEGAL_HOSTING_TEXT",
  TERMS_LEGAL_HOSTING_LI_BOLD_1: "TERMS_LEGAL_HOSTING_LI_BOLD_1",
  TERMS_LEGAL_HOSTING_LI_TEXT_1: "TERMS_LEGAL_HOSTING_LI_TEXT_1",
  TERMS_LEGAL_HOSTING_LI_BOLD_2: "TERMS_LEGAL_HOSTING_LI_BOLD_2",
  TERMS_LEGAL_HOSTING_LI_TEXT_2: "TERMS_LEGAL_HOSTING_LI_TEXT_2",
  TERMS_LEGAL_HOSTING_LI_BOLD_3: "TERMS_LEGAL_HOSTING_LI_BOLD_3",
  TERMS_LEGAL_HOSTING_LI_TEXT_3: "TERMS_LEGAL_HOSTING_LI_TEXT_3",
  TERMS_LEGAL_HOSTING_LI_BOLD_4: "TERMS_LEGAL_HOSTING_LI_BOLD_4",
  TERMS_LEGAL_HOSTING_LI_TEXT_4: "TERMS_LEGAL_HOSTING_LI_TEXT_4",
  TERMS_1_TITLE: "TERMS_1_TITLE",
  TERMS_1_TEXT: "TERMS_1_TEXT",
  TERMS_2_TITLE: "TERMS_2_TITLE",
  TERMS_2_1_TITLE: "TERMS_2_1_TITLE",
  TERMS_2_1_TEXT: "TERMS_2_1_TEXT",
  TERMS_2_1_LI_1: "TERMS_2_1_LI_1",
  TERMS_2_1_LI_2: "TERMS_2_1_LI_2",
  TERMS_2_1_LI_3: "TERMS_2_1_LI_3",
  TERMS_2_1_LI_4: "TERMS_2_1_LI_4",
  TERMS_2_1_LI_5: "TERMS_2_1_LI_5",
  TERMS_2_1_LI_6: "TERMS_2_1_LI_6",
  TERMS_2_1_LI_7: "TERMS_2_1_LI_7",
  TERMS_2_1_LI_8: "TERMS_2_1_LI_8",
  TERMS_2_1_LI_9: "TERMS_2_1_LI_9",
  TERMS_2_2_TITLE: "TERMS_2_2_TITLE",
  TERMS_2_2_TEXT: "TERMS_2_2_TEXT",
  TERMS_2_3_TITLE: "TERMS_2_3_TITLE",
  TERMS_2_3_TEXT: "TERMS_2_3_TEXT",
  TERMS_3_TITLE: "TERMS_3_TITLE",
  TERMS_3_1_TITLE: "TERMS_3_1_TITLE",
  TERMS_3_1_TEXT: "TERMS_3_1_TEXT",
  TERMS_3_2_TITLE: "TERMS_3_2_TITLE",
  TERMS_3_2_TEXT: "TERMS_3_2_TEXT",
  TERMS_4_TITLE: "TERMS_4_TITLE",
  TERMS_4_1_TITLE: "TERMS_4_1_TITLE",
  TERMS_4_1_TEXT: "TERMS_4_1_TEXT",
  TERMS_4_1_LI_1: "TERMS_4_1_LI_1",
  TERMS_4_1_LI_2: "TERMS_4_1_LI_2",
  TERMS_4_1_LI_3: "TERMS_4_1_LI_3",
  TERMS_4_1_LI_4: "TERMS_4_1_LI_4",
  TERMS_4_2_TITLE: "TERMS_4_2_TITLE",
  TERMS_4_2_TEXT: "TERMS_4_2_TEXT",
  TERMS_4_3_TITLE: "TERMS_4_3_TITLE",
  TERMS_4_3_TEXT: "TERMS_4_3_TEXT",
  TERMS_4_4_TITLE: "TERMS_4_4_TITLE",
  TERMS_4_4_TEXT: "TERMS_4_4_TEXT",
  TERMS_4_5_TITLE: "TERMS_4_5_TITLE",
  TERMS_4_5_TEXT: "TERMS_4_5_TEXT",
  TERMS_4_6_TITLE: "TERMS_4_6_TITLE",
  TERMS_4_6_TEXT: "TERMS_4_6_TEXT",
  TERMS_5_TITLE: "TERMS_5_TITLE",
  TERMS_5_1_TITLE: "TERMS_5_1_TITLE",
  TERMS_5_1_TEXT: "TERMS_5_1_TEXT",
  TERMS_5_2_TITLE: "TERMS_5_2_TITLE",
  TERMS_5_2_TEXT: "TERMS_5_2_TEXT",
  TERMS_5_3_TITLE: "TERMS_5_3_TITLE",
  TERMS_5_3_TEXT: "TERMS_5_3_TEXT",
  TERMS_6_TITLE: "TERMS_6_TITLE",
  TERMS_6_1_TITLE: "TERMS_6_1_TITLE",
  TERMS_6_1_TEXT: "TERMS_6_1_TEXT",
  TERMS_6_2_TITLE: "TERMS_6_2_TITLE",
  TERMS_6_2_TEXT: "TERMS_6_2_TEXT",
  TERMS_6_3_TITLE: "TERMS_6_3_TITLE",
  TERMS_6_3_TEXT: "TERMS_6_3_TEXT",
  TERMS_6_4_TITLE: "TERMS_6_4_TITLE",
  TERMS_6_4_TEXT: "TERMS_6_4_TEXT",
  TERMS_6_4_LI_1: "TERMS_6_4_LI_1",
  TERMS_6_4_LI_2: "TERMS_6_4_LI_2",
  TERMS_6_4_LI_3: "TERMS_6_4_LI_3",
  TERMS_6_4_LI_4: "TERMS_6_4_LI_4",
  TERMS_6_4_LI_5: "TERMS_6_4_LI_5",
  TERMS_6_4_NOTE: "TERMS_6_4_NOTE",
  TERMS_6_5_TITLE: "TERMS_6_5_TITLE",
  TERMS_6_5_TEXT: "TERMS_6_5_TEXT",
  TERMS_6_6_TITLE: "TERMS_6_6_TITLE",
  TERMS_6_6_TEXT: "TERMS_6_6_TEXT",
  TERMS_7_TITLE: "TERMS_7_TITLE",
  TERMS_7_1_TITLE: "TERMS_7_1_TITLE",
  TERMS_7_1_TEXT: "TERMS_7_1_TEXT",
  TERMS_7_2_TITLE: "TERMS_7_2_TITLE",
  TERMS_7_2_TEXT: "TERMS_7_2_TEXT",
  TERMS_7_3_TITLE: "TERMS_7_3_TITLE",
  TERMS_7_3_TEXT: "TERMS_7_3_TEXT",
  TERMS_8_TITLE: "TERMS_8_TITLE",
  TERMS_8_1_TITLE: "TERMS_8_1_TITLE",
  TERMS_8_1_TEXT: "TERMS_8_1_TEXT",
  TERMS_8_2_TITLE: "TERMS_8_2_TITLE",
  TERMS_8_2_TEXT: "TERMS_8_2_TEXT",
  TERMS_8_2_LI_1: "TERMS_8_2_LI_1",
  TERMS_8_2_LI_2: "TERMS_8_2_LI_2",
  TERMS_8_2_NOTE: "TERMS_8_2_NOTE",
  TERMS_8_3_TITLE: "TERMS_8_3_TITLE",
  TERMS_8_3_TEXT: "TERMS_8_3_TEXT",
  TERMS_9_TITLE: "TERMS_9_TITLE",
  TERMS_9_TEXT: "TERMS_9_TEXT",
  TERMS_10_TITLE: "TERMS_10_TITLE",
  TERMS_10_TEXT: "TERMS_10_TEXT",
  TERMS_10_LI_1: "TERMS_10_LI_1",
  TERMS_10_LI_2: "TERMS_10_LI_2",
  TERMS_10_LI_3: "TERMS_10_LI_3",
  TERMS_10_LI_4: "TERMS_10_LI_4",
  TERMS_10_LI_5: "TERMS_10_LI_5",
  TERMS_10_LI_6: "TERMS_10_LI_6",
  TERMS_10_NOTE: "TERMS_10_NOTE",
  TERMS_11_TITLE: "TERMS_11_TITLE",
  TERMS_11_TEXT: "TERMS_11_TEXT",
  TERMS_12_TITLE: "TERMS_12_TITLE",
  TERMS_12_TEXT: "TERMS_12_TEXT",
  TERMS_FORCE_MAJEURE_TITLE: "TERMS_FORCE_MAJEURE_TITLE",
  TERMS_FORCE_MAJEURE_TEXT: "TERMS_FORCE_MAJEURE_TEXT",
  TERMS_DIVISIBILITE_TITLE: "TERMS_DIVISIBILITE_TITLE",
  TERMS_DIVISIBILITE_TEXT: "TERMS_DIVISIBILITE_TEXT",
  TERMS_13_TITLE: "TERMS_13_TITLE",
  TERMS_13_TEXT: "TERMS_13_TEXT",
  TERMS_14_TITLE: "TERMS_14_TITLE",
  TERMS_14_TEXT: "TERMS_14_TEXT",
  TERMS_END_TEXT: "TERMS_END_TEXT",
} as const;
